import { render, staticRenderFns } from "./notaVentaConsulta.vue?vue&type=template&id=c98884e0&scoped=true&"
import script from "./notaVentaConsulta.vue?vue&type=script&lang=js&"
export * from "./notaVentaConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98884e0",
  null
  
)

export default component.exports